import styled from 'styled-components'

export const Container = styled.div `
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 100%;
    margin-top: 30px;

    .title {
        margin-bottom: 20px;
    }

    .swiper {
        padding-right: 15px;
        width: 95dvw;
        max-width: 1200px;
    }

    .person {
        transition: all .2s ease;
        color: #fff;
        background: unset;
        border-radius: 5px;
        border: 2px solid transparent;
        padding-bottom: 5px;
        margin: 5px 1px 3px 2px;
    }

    .person img {
        min-height: 9rem;
        max-height: 9rem;
        min-width: 8rem;
        max-width: 8rem;
        object-fit: cover;
        border-radius: 5px;
        background: #303030;
    }

    .person .section-person-details {
        display: flex;
        flex-direction: column;
    }

    .person .section-person-details span {
        font-size: 12px;
        white-space: nowrap;
        text-align: start;
        padding: 0 2px;
        max-width: 15ch;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .person .section-person-details .name {
        font-weight: 600;
        color: #fff;
    }

    .person .section-person-details .character {
        color: #ddd;
    }

    .container-button-see-more {
        display: flex;
        align-items: center;
        height: 160px;
        padding: 0 10px;
    }

    .container-button-see-more button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 38px;
        width: 38px;
        cursor: pointer;
        background: #30303099;
        color: #fff;
        border: 2px solid #aaa;
        border-radius: 50px;
        transition: all .2s ease;
    }

    .container-button-see-more button:hover {
        background: #404040;
        border: 2px solid #fff;
    }

    @media (max-width: 600px) {

        .title {
            margin-bottom: 10px;
        }

        .container-button-see-more {
            height: 110px;
        }

        .person img {
            min-height: 6rem;
            max-height: 6rem;
            min-width: 6rem;
            max-width: 6rem;
        }

        .person .section-person-details span {
            max-width: 14ch;
        }
    }

`